module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_red-joker.1dcfe481.svg";